"use client";

import Link from "next/link";
import { FOOTER_GROUPS } from "@/components/ui/footerItems";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-surface border-t border-border text-textSecondary">
      <div className="mx-auto max-w-6xl px-4 py-10">
        <div className="grid gap-10 md:grid-cols-3">
          {/* Brand */}
          <div className="space-y-3">
            <div className="text-textPrimary font-semibold">ReloadPi</div>

            <p className="text-xs leading-relaxed">
              Buy Vouchers Mobile Airtime Bundles Topups Esims eBooks with Crypto, Bitcoin, Pi Coin  USDC
            </p>

            <a
              href="mailto:team@reloadpi.com"
              className="inline-flex text-xs text-primary hover:underline"
            >
              team@reloadpi.com
            </a>
          </div>

          {/* Groups */}
          <div className="md:col-span-2">
            <div className="grid gap-8 sm:grid-cols-3">
              {FOOTER_GROUPS.map((group) => (
                <div key={group.key} className="space-y-3">
                  <div className="text-textPrimary text-sm font-semibold">
                    {group.title}
                  </div>

                  <ul className="space-y-2 text-xs">
                    {group.items.map((item) => (
                      <li key={item.key}>
                        {item.external ? (
                          <a
                            href={item.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline text-textSecondary hover:text-textPrimary"
                          >
                            {item.label}
                          </a>
                        ) : (
                          <Link
                            href={item.href}
                            className="hover:underline text-textSecondary hover:text-textPrimary"
                          >
                            {item.label}
                          </Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-border pt-6 text-center text-xs md:flex-row md:text-left">
          <div>ReloadPi © {year}</div>
         <div>
            Built by{" "}
            <a
              href="https://www.linkedin.com/in/albu-razvan-vasile"
              target="_blank"
              rel="noopener noreferrer"
              className="text-textPrimary font-medium hover:underline"
            >
              Razvan Albu
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
